import GalleryServices from '../services';
import ViewerVM from '../detail/viewer-vm';
export default function (data, parent) {
  let self = ko.mapping.fromJS(data);

  self.keysToWatch = ['title', 'description', 'public', 'downloadable'];
  self.icons = {
    text: 'text',
    code: 'code-brackets',
    url: 'link',
    reaktor: 'reaktor',
    ableton: 'ableton',
    compressed: 'zip',
    video: 'video',
    audio: 'audio',
    image: 'image',
    pdf: 'pdf'
  };
  self.snapshot = {};


  self.fileTypeIcon = false;
  if(_.indexOf(_.keys(self.icons), self.submitted_file_types()[0]) !== -1) {
    self.fileTypeIcon = 'kf-' + self.icons[self.submitted_file_types()[0]];
  }


  self.takeSnapshot = function() {
    _.each(self.keysToWatch, function(key) { self.snapshot[key] = _.isObject(self[key]()) ? self[key]().toString() : self[key](); });
  };

  self.restoreSnapshot = function() {
    _.each(self.keysToWatch, function(key) {
      if (_.has(self.snapshot, key))
        self[key](self.snapshot[key]);
    });
  };

  self.gradientClass = ko.computed(function () {
    let className = null;
    if (_.isEmpty(self.thumbnail_image())) {
      let gradient_index = self.id() % Kadenze.GRADIENTS.length;
      className = Kadenze.GRADIENTS[gradient_index];
    }
    return className;
  });

  self.getCourseworkEntry = _.memoize(function (params) {
    return new Kadenze.AjaxRequest({
      type: 'GET',
      url: Kadenze.Routes.course_gallery_coursework_coursework_entry_path(self.course_id(), self.coursework_id(), self.id(), params)
    });
  });

  self.getCourseList = _.memoize(function () {
    return JSON.parse($('#course_listing_json').val());
  });

  self.getCourseworkList = _.memoize(function () {
    return JSON.parse($('#coursework_listing_json').val());
  });

  self.initCourseworkEntryViewer = function (mode) {
    //TODO: Fix modal show/hide hack
    Kadenze.UIUtil.showLoadingIndicator();

    let $modal = $('#coursework_entry_viewer_modal');
    let $viewer = $('#js-coursework-viewer');
    let sortOrder = parent.params.sort() || 'date_submitted';

    $modal.off('hide.bs.modal').on('hide.bs.modal', function() {
      parent.refreshURL();
    });

    self.getCourseworkEntry({sort: sortOrder}).done(function (response) {
      let data = {
        coursework_entry: response,
        course_list: self.getCourseList(),
        coursework_list: self.getCourseworkList(),
        user_type: parent.userType(),
        browsing_scope: parent.browsingScope(),
        referrer: {
          title: 'Gallery',
          action: function (vm) {
            $modal.modal('hide');
            $('body').removeClass('modal-open');
            $('.modal-backdrop').fadeOut(150);
            $viewer.hide();

            vm.pauseCurrentSlide();
            vm.hideTooltips();
            vm.clearFullViewTimeout();

            parent.refreshURL();

            if (window.event) {
              window.event.stopImmediatePropagation();
            }
          }
        },
        onInitialize: _.once(function (vm) {
          //If the index page is browsing all course/work, reflect that in the viewer
          vm.selectedCourseworkId(parent.params.coursework().id());
        }),
        onReady: _.once(function (vm) {
          //When VM is initialized
          Kadenze.UIUtil.hideLoadingIndicator();
          $modal.modal({backdrop: !Kadenze.UIUtil.isMobileOrTablet()}).modal('show');
          $viewer.show();

          vm.courseworkEntriesSort(sortOrder); //Make sure index & detail are sorting the entires in the same order
          vm.loadingContainerId('#js-coursework-viewer'); //Specify where the loading indicator should show up
          vm.totalCommentCount.subscribe(function (count) { //Keep the comment count in sync between the viewer and the index card
            if (vm.courseworkEntry().id() == self.id()) {
              self.comment_count(count);
              parent.deleteRequestCache();
            }
          });
          vm.courseworkEntry().favorited.subscribe(self.toggleFavorite); //Keep the favorite count in sync between the viewer and the index card
        }),
        onLoad: _.once(function (vm) {
          //When UI is rendered
          vm.refreshURL({});

          if (mode == 'comment') {
            vm.showComment();
            if (!vm.mobileView()) {
              vm.addNewComment();
            }
          }

          //Set focus on the header logo when modal is shown
          setTimeout(function() { $viewer.find('.coursework-viewer__header_dropdown').first().find('button').focus(); }, 100);
        })
      };
      let vm = new ViewerVM(data);
      ko.cleanNode($viewer[0]);
      ko.applyBindings(vm, $viewer[0]);
    }).fail(function(response) {
      Kadenze.UIUtil.hideLoadingIndicator();
      new Kadenze.Notice.error({ message: response.responseJSON.message });
    });;
  };

  self.shareTooltipAttr = function () {
    let title = 'Share';
    if (!self.public()) {
      title = 'Sharing disabled by user';
    } else if (!self.coursework.has_shareable_fields()) {
      title = 'Coursework not shareable';
    }
    return {content: title, position: 'topCenter'};
  };

  self.share = function (item, event) {
    if (item.public() && item.coursework.has_shareable_fields()) {
      Kadenze.Analytics.track('coursework_entry', 'share', {entry: ko.mapping.toJS(self.tracking_data)});
      let params = {modal_title: 'Share this submission',
        shareableObj: {title: 'Kadenze',
          description: 'Kadenze brings together educators, artists, and engineers from leading universities to provide world-class education in the fields of art and creative technology.',
          share_url: item.share_url(),
          coursework_entry_share_path: Kadenze.Routes.course_gallery_coursework_coursework_entry_share_path(self.course_id(), self.coursework_id(), self.id())},
        emailShareCb: GalleryServices.shareSubmission};
      let modal = new Kadenze.ShareModal(params);
      modal.show();
    }
  };

  self.view = function () {
    Kadenze.Analytics.track('coursework_entry', 'view', {entry: ko.mapping.toJS(self.tracking_data)});
    if (parent.publicView()) {
      window.location = self.detail_path();
    } else {
      self.initCourseworkEntryViewer('view');
    }
  };

  self.comment = function () {
    Kadenze.Analytics.track('coursework_entry', 'view', {entry: ko.mapping.toJS(self.tracking_data)});
    if (parent.publicView()) {
      window.location = Kadenze.Util.insertURLParam(self.detail_path(), 'view', 'comment');
    } else {
      self.initCourseworkEntryViewer('comment');
    }
  };

  self.toggleFavorite = function () {
    parent.deleteRequestCache();

    let favorited = self.favorited();
    self.favorited(!favorited);
    if (self.favorited()) {
      self.favorite_count(self.favorite_count() + 1);
    } else {
      self.favorite_count(self.favorite_count() - 1);
    }
  };

  self.favorite = function () {
    if (parent.publicView()) {
      window.location = Kadenze.Routes.new_user_session_path();
      return;
    }

    self.toggleFavorite();

    self.getCourseworkEntry.cache = {};

    let request = new Kadenze.AjaxRequest({
      url: Kadenze.Routes.course_gallery_coursework_coursework_entry_favorite_path(self.course_id(), self.coursework_id(), self.id())
    });

    request.fail(function(xhr, status, msg) {
      self.toggleFavorite();
    });
  };

  self.toggleFeature = function () {
    parent.deleteRequestCache();

    let featured = self.featured();
    self.featured(!featured);
  };

  self.feature = function () {
    if (!self.can_feature()) {
      return;
    }

    self.toggleFeature();

    self.getCourseworkEntry.cache = {};

    let request = new Kadenze.AjaxRequest({
      url: Kadenze.Routes.course_gallery_coursework_coursework_entry_feature_path(self.course_id(), self.coursework_id(), self.id())
    });

    request.fail(function(xhr, status, msg) {
      self.toggleFeature();
    });
  };

  self.edit = function () {
    self.takeSnapshot();

    let $modal = $('#edit_gallery_info_modal');
    ko.cleanNode($modal[0]);
    ko.applyBindingsWithValidation(self, $modal[0], Kadenze.Knockout.DEFAULT_VALIDATION_OPTIONS);

    $modal.modal('show');

    $modal.on('shown.bs.modal', function (e) {
      Kadenze.UIUtil.initExpandableTextareas();
    });
  };

  self.cancel = function () {
    self.restoreSnapshot();
    $('#edit_gallery_info_modal').modal('hide');
  };

  self.update = function () {
    self.client_errors = ko.validation.group([self.title, self.description]);
    if (self.client_errors().length > 0)
      return;

    let data = ko.mapping.toJS(self, {only: ['id', 'title', 'description', 'public', 'downloadable']});

    let request = new Kadenze.AjaxRequest({
      url: Kadenze.Routes.course_gallery_coursework_coursework_entry_path(self.course_id(), self.coursework_id(), self.id()),
      type: 'PATCH',
      dataAsJSON: false,
      data: {coursework_entry: data},
      loadingIndicator: {
        container: '#edit_gallery_info_modal'
      }
    });

    request.done(function (response, status, xhr) {
      self.getCourseworkEntry.cache = {};
      parent.deleteRequestCache();

      new Kadenze.Notice.success();

      $('#edit_gallery_info_modal').modal('hide');
    });

    request.fail(function(xhr, status, msg) {
      new Kadenze.Notice.error({ message: Kadenze.I18n.t('notice.unexpected_error') });
    });
  };

  return self;
}

